/*
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-12-02 13:09:28
 * @LastEditors: dudedu
 * @LastEditTime: 2022-12-09 15:56:44
 */
import * as utils from './utils';

export const UTIL = utils;

// module.exports = {

// }
